import { render, staticRenderFns } from "./VideoCourseDetail.vue?vue&type=template&id=0ae104ae&scoped=true"
import script from "./VideoCourseDetail.vue?vue&type=script&lang=js"
export * from "./VideoCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoCourseDetail.vue?vue&type=style&index=0&id=0ae104ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae104ae",
  null
  
)

export default component.exports